import { SearchFilterResultTypeBlueprint } from '@backstage/plugin-search-react/alpha';
import GavelIcon from '@material-ui/icons/Gavel';

// @backstage-community/plugin-adr doesn't register a Result Type filter, so
// ADR results only ever show up under "All results". This adds it as its own
// entry in the search page's Result Type accordion, matching how the
// Software Catalog and Documentation types are presented.
export const adrSearchResultType = SearchFilterResultTypeBlueprint.make({
  params: {
    value: 'adr',
    name: 'Architectural Decision Records',
    icon: <GavelIcon />,
  },
});
